export const isSharedYsvAdmin = (user) => user?.role === "ysv_admin";

export const resolveAdminSession = ({
  viewerUser,
  viewerLoading,
  viewerLogout,
}) => {
  const sharedAdmin = isSharedYsvAdmin(viewerUser);

  return {
    user: sharedAdmin ? viewerUser : false,
    signedIn: Boolean(viewerUser),
    loading: viewerLoading,
    logout: viewerLogout,
  };
};
